import React, {useCallback, useEffect} from "react";
import IMG from "../../constants/image";
import popupStore from "../../store/popupStore";
import FormCanceled from "./FormOrder/FormCanceled";
import ImageBasic from "../Common/Image/ImageBasic";
import {text} from "../../constants/text";
import {clsx} from "clsx";
import {isMobile} from "react-device-detect";
import {formatCurrency} from "../../utils";
import {setConfirmOrderSuccess} from "../../network/orderApi";
import {fetchOrderCountStatusAllTime, fetchOrderDetail, fetchOrderNotes} from "../../services/orderServices";
import appStore from "../../store/appStore";
import {useOrdersStore} from "../../store/orderStore";
import FormRefund from "./FormOrder/FormRefund";
import FutaOrderConfirmationModular from "../shipping/FutaOrderConfirmationModular";
import ShippingConfirmationForm from "../shipping/ShippingConfirmationForm";
import FormNote from "./FormOrder/FormNote";

const OrderSummary = ({
                        data,
                        addressShip,
                        orderStatus,
                        orderGroupId,
                        isDetail = false,
                      }) => {
  const {setActiveTab, activeTabConfirm, setSellerIdConfirm, setLoading} = appStore()
  const {orderNotes} = useOrdersStore()

  useEffect(() => {
    if (isDetail && orderGroupId) {
      fetchOrderNotes(orderGroupId, {page: 1, size: 15})
    }
  }, [isDetail, orderGroupId])

  const {isCancelled, isPending, isProcessing} = orderStatus || {}
  const {subTotal, totalPayment, orderItems, shippingFee, shipping, cancelRefundReason} = data || {}
  const {userAddr, trackingInfo} = shipping || {}
  const {logisticsProvider, trackingNumber} = trackingInfo || {}
  const {phoneNumber, name} = userAddr || {}
  const {setPopup, setPopupMobile, isOpenMobile, data: popupData} = popupStore()
  const typeShippingPartner = data?.shipping?.shippingMethod === 2
  const handleCanceled = useCallback(() => {
    setPopup({
      isOpen: true,
      data: {
        customContent: () => <FormCanceled orderId={orderGroupId} phoneNumber={phoneNumber}/>
      }
    });
  }, [setPopup, orderGroupId, phoneNumber]);
  const handleRefund = useCallback(() => {
    setPopup({
      isOpen: true,
      data: {
        customContent: () => <FormRefund orderId={orderGroupId} phoneNumber={phoneNumber}/>
      }
    });
  }, [setPopup, orderGroupId, phoneNumber]);

  const handleNote = useCallback(() => {
    setPopup({
      isOpen: true,
      data: {
        bgClass: 'bg-[#f7eeb7]',
        customContent: () => <FormNote orderId={orderGroupId} isDetail={isDetail}/>
      }
    });
  }, [setPopup, orderGroupId, isDetail]);

  const handleConfirm = () => {
    setSellerIdConfirm(orderGroupId)
    if (isMobile) {
      setPopupMobile({
        isOpenMobile: true,
        data: {
          orderId: orderGroupId,
          height: typeShippingPartner
            ? activeTabConfirm === 'pickup'
              ? 'h-[90%]'
              : 'h-[65%]'
            : 'h-[80%]',
          top: typeShippingPartner
            ? activeTabConfirm === 'pickup'
              ? 'top-[12%]'
              : 'top-[35%]'
            : 'top-[30%]',
          children: typeShippingPartner
            ? <FutaOrderConfirmationModular
              orderGroupId={orderGroupId}
              onClose={() => setPopupMobile({})}
            />
            : <ShippingConfirmationForm title={'Xác nhận đơn hàng'} orderId={orderGroupId}/>
        }
      })
    } else {
      setPopup({
        isOpen: true,
        data: {
          bgClass: 'bg-[#FAFAFC]',
          buttonCloseClass: 'top-5 right-6',
          customContent: () => {
            if (typeShippingPartner) return (
              <FutaOrderConfirmationModular
                orderGroupId={orderGroupId}
                onClose={() => setPopup({})}
              />
            );
            return <ShippingConfirmationForm title={'Xác nhận đơn hàng'} orderId={orderGroupId}/>;
          }
        }
      });
    }
  }
  const handleConfirmSuccess = () => {
    return setPopup({
      isOpen: true,
      data: {
        title: 'Xác nhận đơn hàng đã giao thành công',
        image: IMG.popupUpdateStatus,
        btnCancelNew: {
          label: 'Bỏ qua',
          action: () => setPopup({})
        },
        isHideButtonClose: true,
        accept: {
          label: 'Đồng ý',
          action: () => {
            setConfirmOrderSuccess({orderId: orderGroupId}).then((res) => {
              if (res.success) {
                setPopup({})
                fetchOrderCountStatusAllTime()
                setActiveTab('shipping_done')
                fetchOrderDetail(orderGroupId).then(res => {
                  if (res) setLoading(false)
                })
              }
            })
          }
        }
      }
    })
  }

  const renderButton = (onClick, text, extraClasses = '') => {
    return (
      <button onClick={onClick} className={`${buttonClasses} ${extraClasses}`}>
        <div className="w-fit text-[12px]">{text}</div>
      </button>
    );
  }
  // Add this effect to update the popup when activeTabConfirm changes
  useEffect(() => {
    // Only update if the popup is already open and related to this order
    if (isOpenMobile && popupData?.orderId === orderGroupId && isMobile) {
      setPopupMobile({
        isOpenMobile: true,
        data: {
          ...popupData,
          orderId: orderGroupId, // Store orderId to identify this popup
          height: typeShippingPartner
            ? activeTabConfirm === 'pickup'
              ? 'h-[90%]'
              : 'h-[65%]'
            : 'h-[80%]',
          top: typeShippingPartner
            ? activeTabConfirm === 'pickup'
              ? 'top-[12%]'
              : 'top-[35%]'
            : 'top-[30%]',
        }
      });
    }
  }, [activeTabConfirm, isOpenMobile, orderGroupId]);
  const buttonClasses =
    'flex items-center space-x-1 border border-[#828282] rounded-2xl md:rounded-2xl w-fit px-4 md:px-3 py-1 cursor-pointer';

  return (
    <div className='bg-[#F3F8F6] p-4 text-sm relative flex flex-col gap-4'>
      <div className='flex justify-between gap-4'>
        <div className='hidden md:block text-sm flex-1'>
          <div>Người mua:</div>
          <div className='font-bold'>{`${name} `}<span className='font-normal'>{`- ${phoneNumber}`}</span>
          </div>
          <div className='text-xs text-gray-500'>{addressShip}</div>
          {(!isCancelled && !isPending) && (logisticsProvider || trackingNumber) &&
            <div className='bg-white p-3 rounded-[5px] w-fit mt-2 border border-dashed border-gray-200'>
              {logisticsProvider && <div>Vận chuyển bởi: {logisticsProvider}</div>}
              {trackingNumber && <div>Mã vận đơn: <span>{trackingNumber}</span></div>}
            </div>
          }
          {(isCancelled && cancelRefundReason) && (
            <div className='hidden md:flex space-x-2 mt-2'>
              <ImageBasic className='w-5 h-5' src={IMG.icon.errorOutlineBlack}/>
              <div className=' text-xs'>
                <div>Lý do huỷ:</div>
                <div className='text-gray-500'>{cancelRefundReason}</div>
              </div>
            </div>
          )}
        </div>
        <div className='w-full md:w-auto text-end'>
          <div className="flex justify-between space-x-10 md:space-x-20">
            <div className='min-w-[150px] md:min-w-[200px] text-right text-gray-500'>Tổng cộng ({orderItems?.length} sản
              phẩm):
            </div>
            <div className="font-normal">{`${formatCurrency(subTotal)}đ`}</div>
          </div>
          <div className="flex justify-between mt-2 space-x-10 md:space-x-20">
            <div className='min-w-[150px] md:min-w-[200px] text-right text-gray-500'>{`${text.shippingCost}:`}</div>
            <div
              className={clsx(isPending ? 'text-black' : '')}>
              {`${isPending ? 'chưa xác định' : `${formatCurrency(shippingFee)}đ`}`}
            </div>
          </div>
          <div className="flex justify-between mt-2 space-x-10 md:space-x-20">
            <div
              className='min-w-[150px] md:min-w-[200px] text-right text-black font-bold'>{`${text.totalAmount}:`}</div>
            <div className="font-bold text-[#FF0000] text-lg">{`${formatCurrency(totalPayment)}đ`}</div>
          </div>
          <div className="mt-3 md:mt-4 flex flex-wrap justify-center md:justify-end gap-2">
            {isPending &&
              renderButton(handleConfirm, text.confirm, 'bg-[#F8C518] border-none')}
            {isProcessing &&
              renderButton(handleConfirmSuccess, text.confirmDelivered, 'bg-[#F8C518] border-none')}
            {isProcessing &&
              renderButton(handleRefund, text.refund)}
            {(isPending) &&
              renderButton(handleCanceled, text.cancelOrder)}
            {isPending &&
              renderButton(handleNote, text.noteOrder)}
          </div>
          {(isCancelled && cancelRefundReason) &&
            <div className='md:hidden flex items-center justify-end space-x-2 text-right text-xs mt-3'>
              <ImageBasic src={IMG.icon.errorOutlineBlack} alt="adress"/>
              <div>{`${text.reasonCancel}: ${cancelRefundReason}`}</div>
            </div>}
        </div>
      </div>
      {((isDetail ? orderNotes?.items : data?.notes) || [])?.length > 0 && isPending && (
        <div className='w-full'>
          <div className='font-bold mb-2'>{text.note}</div>
          <div className='space-y-3 overflow-y-auto max-h-[300px]'>
            {((isDetail ? orderNotes?.items : data?.notes) || []).map((note, index) => (
              <div key={index} className='text-xs last:pb-0 border-b last:border-b-0 border-gray-50'>
                <div className='flex gap-2 text-gray-500'>
                  <div className='w-8 h-8 rounded-full bg-gray-100 flex justify-center shrink-0'>
                    <ImageBasic src={IMG.icon.userCircle} className='w-8 h-8'/>
                  </div>
                  <div className='p-2 rounded-lg border border-gray-200 bg-white w-full'>
                    <div className="flex flex-wrap gap-1">
                      <span className="font-semibold text-black">{note.authorName}</span>
                      <span className="text-gray-400">-</span>
                      <span>{new Date(note.createdAt).toLocaleTimeString('vi-VN')}</span>
                      <span className="text-gray-400">-</span>
                      <span>{new Date(note.createdAt).toLocaleDateString('vi-VN')}</span>
                    </div>
                    <div className='text-gray-700 leading-relaxed'>{note.content}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
export default OrderSummary;
